import { render, staticRenderFns } from "./ArrivalAirportDetailsTable.vue?vue&type=template&id=460bac6b"
import script from "./ArrivalAirportDetailsTable.vue?vue&type=script&lang=js"
export * from "./ArrivalAirportDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports